import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import {
  FilterDTO,
  IPagedResultDTOOfTripDTO,
  SortDirection,
  StatisticsClient,
  TripDetailDTO,
} from 'src/app/base/models/models.swagger.generated';

@Injectable()
export class TripOverviewService extends ShowInactiveService implements IAdaptorService {

  public vehicleId: number | null = null;

  constructor(
    private statisticsClient: StatisticsClient,
    private toastService: ToastService,
  ) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<IPagedResultDTOOfTripDTO | null> {
    if (!this.vehicleId) {
      return of({ items: [], totalNumberOfItems: 0 });
    }

    return this.statisticsClient.searchTrips(filters, this.vehicleId, skip, take, sortBy, sortDirection)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', '', ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public getTripDetail(tripId: number): Observable<TripDetailDTO | null> {
    return this.statisticsClient.getTrip(tripId)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', '', ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public addRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: trip data is read-only.'));
  }

  public updateRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: trip data is read-only.'));
  }

  public deleteRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: trip data is read-only.'));
  }
}
